import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Resolves true when confirmed, undefined when dismissed
export const ConfirmDialog = ({
  closeDialog,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
}) => {
  return (
    <Dialog open fullWidth maxWidth="xs" onClose={() => closeDialog()}>
      <DialogTitle>{title}</DialogTitle>
      {message && (
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="outlined" onClick={() => closeDialog()}>
          {cancelLabel}
        </Button>
        <Button variant="contained" color={confirmColor} onClick={() => closeDialog(true)} autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
